export abstract class AdminPage {
	abstract GetTemplate();

	AfterRender(el) {
	}
}